module.exports = __webpack_public_path__ + "static/img/rowBacGround.6e19f533.png";